import { useEffect, useRef } from "react"
import "./Modal.scss"

interface Props {
    onCancel: () => void
    children: string | JSX.Element | JSX.Element[]
}

const Modal = (props: Props) => {
    const { children, onCancel } = props
    const modalRef = useRef<HTMLDivElement>(null)

    

    

    useEffect(() => {
        const handleClickOutside = (e: any) => {
            if(!(modalRef?.current && modalRef?.current.contains(e.target))) {
                onCancel()
                e.preventDefault()
            }
        }

        const handleKeyDown = (e: any) => {
            if(e.key === 'Escape') {
                onCancel()
            }
        }
        
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [onCancel])

    

    return <div className="modal-frame">
        <div className="modal-content" ref={modalRef}>
            { children }
        </div>
    </div>
}

export default Modal